import { Controller } from "@hotwired/stimulus"

// Fa scorrere il contatore del timer in pagina. Il server resta la fonte di
// verità (le ore si calcolano da started_at/stopped_at al momento dello stop):
// qui si aggiorna solo quello che si legge, ogni minuto.
export default class extends Controller {
  static values = { startedAt: String }

  connect() {
    this.render()
    this.interval = setInterval(() => this.render(), 60_000)
  }

  disconnect() {
    clearInterval(this.interval)
  }

  render() {
    const minutes = Math.max(0, Math.round((Date.now() - Date.parse(this.startedAtValue)) / 60_000))
    const h = Math.floor(minutes / 60)
    const m = minutes % 60
    this.element.textContent = h === 0 ? `${m}m` : m === 0 ? `${h}h` : `${h}h ${m}m`
  }
}
